/** Routes that use --workspace-max-width (1600) instead of default shell (1400). */
const WORKSPACE_EXACT = new Set(['/desk', '/feed', '/web', '/stringers', '/admin/pipeline-ops']);

export function isWorkspacePath(pathname) {
  if (!pathname) {
    return false;
  }
  if (WORKSPACE_EXACT.has(pathname)) {
    return true;
  }
  return pathname.startsWith('/entity/');
}

/** CSS class fragment for <main> — empty for default / prose-page shells. */
export function workspaceMainClass(pathname) {
  return isWorkspacePath(pathname) ? 'main-content--workspace' : '';
}
